<template>
  <qx-card-form title="车辆信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 车牌号码 -->
      <section slot="plateNumberInfo" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          :disabled="chooseCarDisabled"
          v-model="prop.form.plateNumberInfo"
          :otherSearchData="otherSearchData"
          @change="handleChange"
        />
      </section>

      <section slot="isAddInsurance">
        <p v-show="isAddInsuranceShow" class="notices error">
          注意：本车还没有添加保险信息，请前往
          <span class="primary cur" @click="toAddInsurance">去添加</span>
        </p>
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
// import {
//   getFileUrl,
// } from 'api';
import { getVehicleCertificatesInsuranceForAccident } from 'api/car';
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      otherSearchData: {
        isAccident: true,
      },

      // 是否显示【本车还没有添加保险信息】提示
      isAddInsuranceShow: false,
      chooseCarDisabled: false,
      vehicle: {},
      otherFormData: {
        plateNumber: '',
        vehicleCode: '',
        licenceType: '',
        id: '',
        tenantId: '',
        accidentState: '',
        dealState: '',
        dealUserId: '',
        dealUserName: '',
        dealUserTel: '',
        maintailState: '',
        otherLossAmt: '',
        busiCode: '',
        viceUserId: '',
        viceUserName: '',
        viceUserTel: '',
        woundingRemark: '',
        trailerId: '',
        trailerPlate: '',
        transferDate: '',
        transferPlateNumber: '',
      },
      baseForm: {
        form: [
          {
            label: '车牌号码',
            value: 'plateNumberInfo',
            default: {},
            slot: true,
          },
          {
            label: '车辆归属',
            value: 'orgName',
            type: 'input',
            disabled: true,
          },
          {
            label: '品牌名称',
            value: 'brandModelName',
            type: 'input',
            disabled: true,
          },
          {
            label: '品牌型号',
            value: 'brandModelExt',
            type: 'input',
            disabled: true,
          },
          {
            label: '保险公司',
            value: 'insuranceCompany',
            type: 'input',
            disabled: true,
          },
          {
            label: '被保险人',
            value: 'insuranceUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '起保日期',
            value: 'insuranceStartDate',
            type: 'input',
            disabled: true,
          },
          {
            label: '终保日期',
            value: 'insuranceEndDate',
            type: 'input',
            disabled: true,
          },
          {
            label: '保单号',
            value: 'insuranceNumber',
            type: 'input',
            disabled: true,
          },
          {
            label: '保单号',
            value: 'isAddInsurance',
            allCustom: true,
          },
        ],
        rules: {
          plateNumberInfo: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    // 添加保险信息
    toAddInsurance () {
      this.jump({
        label: '新增保险登记',
        url: '/manage/car/maintain/insurance/edit',
        full: true,
      });
    },
    async handleChange () {
      const plateNumberInfo = this.$refs.baseForm.getVal('plateNumberInfo');
      console.log(plateNumberInfo);
      for (let name in plateNumberInfo) {
        if (name) {
          for (let item of this.baseForm.form) {
            if (item.value === name) {
              this.$refs.baseForm.setVal(name, plateNumberInfo[name] || ' ');
            }
          }
        }
      }
      this.setFormValFromData(this.otherFormData, plateNumberInfo);
      // 车辆事故查询保险信息
      this.getVehicleInsuranceInfo(plateNumberInfo);
    },
    // 获取车辆的保险信息
    async getVehicleInsuranceInfo (plateNumberInfo) {
      const res = await getVehicleCertificatesInsuranceForAccident({
        isClosingCase: '-1',
        // 是否结案 1是 0否
        isRepairComplete: '-1',
        // 是否维修完结 1是 0否
        isVehicleDamage: '-1',
        // 是否本车车损 1是 0否
        isOtherAccident: '-1',
        // 是否对方车事故 1是 0否
        isRoadDamage: '-1',
        // 是否道路损坏 1是 0否
        isGoodsDamage: '-1',
        // 是否货物损坏 1是 0否
        isWounding: '-1',
        // 是否伤人 1是 0否
        accidentResponsibility: '-1',
        licenceType: plateNumberInfo.licenceType,
        vehicleCode: plateNumberInfo.vehicleCode,
        plateNumber: plateNumberInfo.plateNumber,
      });
      if (!res.failed) {
        this.$refs.baseForm.setVal('insuranceNumber', res.insuranceCode || ' ');
        this.$refs.baseForm.setVal('insuranceCompany', res.insuranceCompany || ' ');
        this.$refs.baseForm.setVal('insuranceUserName', res.agentCompany || ' ');
        this.$refs.baseForm.setVal('insuranceStartDate', res.insuranceStartDate || ' ');
        this.$refs.baseForm.setVal('insuranceEndDate', res.insuranceEndDate || ' ');
        if ((res.id === null || res.id === '' || res.id === undefined) && this.$route.query.accidentRegisterState === '1') {
          this.isAddInsuranceShow = true;
        } else {
          this.isAddInsuranceShow = false;
        }
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
        formData.vehicleCode = this.otherFormData.vehicleCode;
        // formData.isAddInsuranceShow = this.isAddInsuranceShow;

        if (formData.plateNumberInfo) {
          formData.plateNumber = formData.plateNumberInfo.plateNumber;
        }

        formData = {
          ...formData,
          ...this.otherFormData,
          vehicle: this.vehicle,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        // 如果是操作【定损】、【核赔】或者【维修】的时候，取 url 的 accidentRegisterState 的值提交
        if (this.$route.query.accidentRegisterState) {
          formData.accidentRegisterState = this.$route.query.accidentRegisterState;
        } else {
          // 如果是操作【修改】的时候，直接取接口返回的 accidentState 字段提交
          formData.accidentRegisterState = formData.accidentState;
        }
        for (let name in this.vehicle) {
          if (this.vehicle[name]) {
            formData[`vehicle.${name}`] = this.vehicle[name];
          }
        }
        delete formData.vehicle;
        delete formData.plateNumberInfo;
      }
      // console.log('base提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      this.chooseCarDisabled = !!this.$route.query.id;

      // this.isAddInsuranceShow = data.isAddInsuranceShow;

      if (data.plateNumber) {
        data.plateNumberInfo = {
          plateNumber: data.plateNumber,
        };
      }

      if (data.vehicle) {
        this.vehicle = data.vehicle;
        data.orgName = data.vehicle.orgName;
        data.brandModel = data.vehicle.brandModel;
        data.brandModelName = data.vehicle.brandModelName;
        data.brandModelExt = data.vehicle.brandModelExt;
      }

      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);

      this.getVehicleInsuranceInfo(data);
    },
  },
};
</script>

<style scoped lang="scss">
.notices {
  margin-left: 120px;
}
</style>
